import { StrictMode } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import './index.css'
import App from './App.tsx'

/*
 * hydrateRoot, niet createRoot: de HTML is bij de build al gerenderd (ADR-0011) en
 * staat er dus al. React neemt hem hier over in plaats van hem opnieuw op te bouwen —
 * dat scheelt de bezoeker een lege eerste weergave.
 */
hydrateRoot(
  document.getElementById('root')!,
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
